import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../../supabase';
import Button from '../Button/Button';
import styles from './Login.module.css';
import { KeyRound } from 'lucide-react';

const Login = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  async function signInWithEmail(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    const form = e.currentTarget;
    const formData = new FormData(form);
    const username = formData.get('username') as string;
    const password = formData.get('password') as string;

    const { error } = await supabase.auth.signInWithPassword({
      email: username,
      password: password,
    });

    setIsLoading(false);

    if (error) {
      setError(error.message);
      return;
    }

    navigate('/');
  }

  return (
    <div className={styles.login}>
      <div className={styles.loginContainer}>
        <h2>Login</h2>
        <form className={styles.loginForm} onSubmit={signInWithEmail}>
          <div className={styles.formGroup}>
            <label htmlFor="username">Email</label>
            <input 
              type="email" 
              id="username" 
              name="username" 
              placeholder="your@email.com"
              required 
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              id="password" 
              name="password" 
              placeholder="••••••••"
              required 
            />
          </div>
          {error && <p className={styles.error}>{error}</p>}
          <Button type="submit" className="submitButton">
            {isLoading ? (
              'Signing in...'
            ) : (
              <>
                <KeyRound className={styles.loginIcon} />
                Sign In
              </>
            )}
          </Button>
        </form>
        <a href="/" className={styles.backLink}>← Back to home</a>
      </div>
    </div>
  );
};

export default Login;
